import React, {Component} from 'react';
import 'bootstrap/scss/bootstrap.scss';
import './app.scss';
import {Route} from 'react-router-dom';
import Contact from "./contact/contact";
import Navigation from "./navigation/navigation";
import Content from "./content/content";
import Footer from "./footer/footer";
import Imprint from "./imprint/imprint";
import PrivacyStatement from "./privacystatement/privacystatement";
import ScrollTop from "./scrollToTop";

class App extends Component {
    render() {
        return (
            <div id="app-wrapper">
                <Contact/>
                <Navigation/>
                <Route path="/" exact component={Content}/>
                <Route path="/impressum" component={Imprint}/>
                <Route path="/datenschutz" component={PrivacyStatement}/>
                <Footer/>
                <ScrollTop/>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js